import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
    loadCustomerTasks
} from '../actions/customer';

export function fetchTasksByCustomer(id, itemsPerPage = 20, currentPage = 1, sortBy = 'task_created', sortDirection = 'desk', search = '') {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/dashboard/tasks?customer_id=${id}&page=${currentPage}&per_page=${itemsPerPage}&sort_type=${sortDirection}&sort_field=${sortBy}${(search ? '&search_query=' + encodeURIComponent(search) : '')}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadCustomerTasks(json));
            }
          })
      }
    }
  }


// WEBPACK FOOTER //
// ./src/api/customer.js